import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, Input } from 'antd'
import EditAlumniEvent from './edit'
import MyIcon from '../../../components/general/icon'
import AddEventQuestion from './question/add'
import EditEventQuestion from './question/edit'
import DeleteEventQuestion from './question/delete'

const AlumniEventDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [eventDetail, setEventDetail] = useState({})
  const [questionList, setQuestionList] = useState([])
  const [propsData, setPropsData] = useState({})
  const [isEditAlumniEventVisible, setIsEditAlumniEventVisible] = useState(false)
  const [isAddQuesitonVisible, setIsAddQuesitonVisible] = useState(false)
  const [isEditQuesitonVisible, setIsEditQuesitonVisible] = useState(false)
  const [isDeleteQuesitonVisible, setIsDeleteQuesitonVisible] = useState(false)
  
  const getAlumniEventDetail = () => {
    axios.post('/p/alumni/event/detail/get', {
      merchant_oid: merchantOid,
      event_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setEventDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const getQuestionList = () => {
    axios.post('/p/alumni/event/question/list/get', {
      merchant_oid: merchantOid,
      event_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setQuestionList(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAlumniEventDetail()
    getQuestionList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  const editAlumniEvent = () => {
    setIsEditAlumniEventVisible(true)
    setPropsData({ oid: props.data.oid })
  }

  const addQuestion = () => {
    setIsAddQuesitonVisible(true)
    setPropsData({ oid: props.data.oid })
  }

  const editQuestion = (oid) => {
    setIsEditQuesitonVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteQuestion = (oid, title) => {
    setIsDeleteQuesitonVisible(true)
    setPropsData({ oid: oid, title: title})
  }

  function formatDescription(html) {
    if (!html) return '暂无活动描述';
    let replaced = html.replace(/<img[^>]*>/gi, ' [图片] ')
    replaced = replaced.replace(/<[^>]+>/g, '')
    return replaced
  }

  const previewDesc = formatDescription(eventDetail.description);

  return (
    <>
      <Modal 
        title='活动详情'
        destroyOnClose={true}
        width='700px'
        open={props.isOpen}
        onCancel={handleCancel}
        footer={false}>

        <div className='forms-collect-container'>
          <div className='forms-collect-name' onClick={editAlumniEvent}>
            <div className='forms-collect-title'>{eventDetail.title}</div>
            <div className='forms-collect-description'>{previewDesc}</div>
          </div>

          {questionList.length > 0 && questionList.map((question, index) => (
            <div className='forms-collect-item' key={question.oid}>
              <div className='forms-collect-item-required'>{question.is_required ? '*' : ''}</div>
              <div className='forms-collect-item-serialNumber'>{`${String(index + 1).padStart(2, '0')}`}</div>

              <div className='forms-collect-item-question' onClick={() => { editQuestion(question.oid) }}>
                <div className='forms-collect-item-title'>
                  <span>{question.title}</span>
                  <div className='forms-collect-item-delete' onClick={(event) => {event.stopPropagation(); deleteQuestion(question.oid, question.title)}}>
                    <MyIcon name='huishouzhan' />
                  </div>
                </div>
                <div className='forms-collect-item-description'>{question.description}</div>
                {question.type === 1 && 
                  <Input
                    disabled
                    placeholder='用户在此输入'
                  />
                }
                {([2, 3].includes(question.type) && question.options.length > 0) && question.options.map((option, optionIndex) => (
                  <div className='forms-collect-item-select' key={option.oid}>
                    {question.type === 2 && <MyIcon name='danxuankuang-moren' />}
                    {question.type === 3 && <MyIcon name='fuxuankuang-moren' />}
                    <span>{option.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className='forms-collect-button' onClick={addQuestion}>添加问题</div>
        </div>
      </Modal>

      {isEditAlumniEventVisible && <EditAlumniEvent
        data={propsData}
        getAlumniEventDetail={getAlumniEventDetail} 
        getEventData={props.getEventData} 
        isOpen={isEditAlumniEventVisible} 
        isCancel={() => { setIsEditAlumniEventVisible(false) }} 
      />}

      {isAddQuesitonVisible && <AddEventQuestion
        data={propsData}
        getQuestionList={getQuestionList}
        isOpen={isAddQuesitonVisible} 
        isCancel={() => { setIsAddQuesitonVisible(false) }} 
      />}

      {isEditQuesitonVisible && <EditEventQuestion
        data={propsData}
        getQuestionList={getQuestionList}
        isOpen={isEditQuesitonVisible}
        isCancel={() => { setIsEditQuesitonVisible(false) }}
      />}

      {isDeleteQuesitonVisible && <DeleteEventQuestion
        data={propsData}
        getQuestionList={getQuestionList}
        isOpen={isDeleteQuesitonVisible}
        isCancel={() => { setIsDeleteQuesitonVisible(false) }}
      />}
    </>
  )
}

export default AlumniEventDetail
